import { connect } from 'react-redux';
import Diary from './Diary';
import { selectors as uiSelectors } from 'ducks/ui';
import { selectors as operationSelectors } from 'ducks/uiOperations';
import { selectors as formSelectors } from 'ducks/form';
import { selectors as orderSelectors } from 'ducks/purchaseOrderEnquiry/purchaseOrder';

const mapStateToProps = (state) => ({
  operationMode: operationSelectors.operationMode(state),
  selectedTab: uiSelectors.selectedTab(state),
  selectedForm: formSelectors.selected(state),
  selectedOrder: orderSelectors.selected(state),
});

export default connect(mapStateToProps, {})(Diary);
